define.alias("shared/components/shared/wizard/slide", "calendar/components/shared/wizard/slide");